import { RenderViewImpactChartParams } from '@upright/common/renderer/component-types/types-render-view-impact-chart';
import { NetImpactChartPlain } from '@upright/ui/common/upright/model/output/scores/net-impact-chart';
import { toChartData } from '../utils';
import styled from 'styled-components';
import { useRenderViewContext } from '../context';

export function RenderViewImpactChart(props: { width: number; params: RenderViewImpactChartParams }) {
  const context = useRenderViewContext();

  // TODO OA: Change to fetch own data with ReactQuery instead of getting it from RenderViewContext
  const { data, options } = context;

  const { width, params } = props;
  const items = options.items;

  if (!items) {
    return <></>;
  }

  const impactChartData = toChartData(items, data);

  const {
    noLeftMargin,
    negativeColor,
    positiveColor,
    language,
    simplify,
    showValueChains,
    hideTitle,
    hideNetScore,
    scoreType,
  } = params;

  return (
    <Root>
      <StyledImpactChart
        noLeftMargin={noLeftMargin}
        negativeColor={negativeColor}
        positiveColor={positiveColor}
        language={language}
        simplify={simplify}
        expandedOnDefault={props.params.isExpanded}
        staticMode={true}
        showValueChains={showValueChains}
        hideTitle={hideTitle}
        bigFonts={options.isShareImg}
        title={''}
        width={width}
        hideValueChainsSwitch
        data={impactChartData}
        hideNetScore={hideNetScore}
        scoreTypeOverride={scoreType}
        alignLineEdges
        showRenderViewButton={false}
      />
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  & > * + * {
    margin-top: 60px;
  }
`;

const StyledImpactChart = styled(NetImpactChartPlain)<{ noLeftMargin: boolean | undefined }>`
  ${props => props.noLeftMargin && 'margin-left: 0;'}
`;
